exports.components = {
  "component---src-module-template-index-tsx": () => import("./../../../src/module/template/index.tsx" /* webpackChunkName: "component---src-module-template-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

